import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { updateFacilityMaintenanceRequest as ticketUpdate } from '../state';
import { updateFacilityMaintenanceRequest as recurringTaskUpdate } from '../../recurringTasks/state';
import { FacilityMaintenanceRequestView } from '../../../types/shared/accessRequestTypes';
import { EditorMode } from '../types/editorTypes';

/**
 * Custom hook that abstracts Redux state selection and dispatch for
 * Facility Maintenance editors. Returns the current request data and
 * a mode-aware update function.
 */
export const useFacilityMaintenanceEditor = (mode: EditorMode) => {
  const dispatch = useAppDispatch();

  const request = useAppSelector(state =>
    mode === 'ticket'
      ? state.ticket.currentTicket?.facilityMaintenanceRequest
      : state.recurringTask.currentRecurringTask?.facilityMaintenanceRequest
  );

  const updateRequest = useCallback(
    (update: Partial<FacilityMaintenanceRequestView>) => {
      if (mode === 'ticket') {
        dispatch(ticketUpdate(update));
      } else {
        dispatch(recurringTaskUpdate(update));
      }
    },
    [dispatch, mode]
  );

  return { request, updateRequest };
};
